<template>
  <div>
    <Top />
    <!-- 标题 -->
    <div class="home trade">
      <h2 class="bt_title">中国对外贸易数据库</h2>
    </div>

    <!-- 选择框 -->
    <div class="home select p5 clearfix" id="searchBar" :class="searchBarFixed == true ? 'searchBar' :''">
      <div class="table_r_box fr">
        <!-- <a class="bg_a" href="https://trade.drcnet.com.cn/data/goods/china/monthly" target="_blank">表格显示</a> -->
        <router-link :to="{name:'databasetable',query:{uid:-8012}}" class="bg_a">表格显示</router-link>
      </div>
      <ul class="screen home clearfix">
        <li class="w25 fl fade">
          <div class="wrap fade">
            <el-select v-model="province">
            </el-select>
          </div>
        </li>
        <li class="w25 fl">
          <div class="wrap">
            <el-select v-model="province" @change="getProvince" filterable placeholder="请选择" size="medium">
              <el-option
                v-for="item in provinces"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </li>

        <li class="w25 fl">
          <div class="wrap">
            <!--  @getValue="getValue($event)" -->
            <SelectTree
              :inputName="country"
              :props="props"
              :options="optionData"
              :options1="optionData1"
              :options2="optionData2"
              :options3="optionData3"
              :clearable="isClearable"
              :accordion="isAccordion" 
              @getValue="getValue($event)"
            />
          </div>
        </li>
        
        <li class="w25 fl">
          <div class="wrap">
            <el-select v-model="port" @change="getPort" filterable placeholder="请选择" size="medium">
              <el-option
                v-for="item in ports"
                :key="item.value"
                :label="item.value"
                :value="item.name"
              ></el-option>
            </el-select>
          </div>
        </li>
        <li class="w25 fl">
          <div class="wrap">
            <treeselect
              v-model="time"
              :options="options"
              :multiple="false"
              :flatten-search-results="true"
              :open-on-focus="false"
              placeholder="请选择时间"
              @input="valueInput(time)"
            />
          </div>
        </li>
      </ul>
    </div>

    <!-- 流向图  -->
    <div class="mapbox">
      <div class="bj_white2 home">
        <!-- 流向图 -->
        <div class="echarts">
          <div :style="{height:'825px',width:'100%'}" ref="myEchart" id="myEchart"></div>
          <!-- <div class="mapboxdownload">
            <el-button type="primary" plain @click="downloadexcel">表格下载</el-button>
          </div>-->
        </div>
      </div>
      <div class="intro">
        <!-- <div ref="pieChart" id="pieChart" style="margin:0 auto; width:100%; height:100px;"></div> -->
        
        <p v-show="showExplain">说明：地图中默认展示相关条件下贸易规模前50大经济体的贸易情况。</p>
        <!-- <p v-show="time === '2020-02-01'">   地图中2020年2月数据为2020年 1-2 月贸易汇总数。</p> -->
        <p style="font-size:14px;">资料来源：图中数据是由海关统计数据在线查询平台（http://43.248.49.97）公布数据汇总得出。</p>
      </div>
    </div>

    <!-- 图表1 -->
    <div class="home p5 clearfix">
      <!-- 左侧 -->
      <div class="dashboard__tabs fl">
        <div class="bj_white2" style="height: 350px;">
          <!-- Tab切换 -->
          <div class="card_title">
            <div class="title">
              <ul class="nav_tab clearfix">
                <li class="fl">
                  <span title="进出口" :class="{onhover:isIExport}" @click="trade_IE('进出口总数')">进出口</span>
                </li>
                <li class="fl">
                  <span title="进口" :class="{onhover:isImport}" @click="trade_I('进口')">进口</span>
                </li>
                <li class="fl">
                  <span title="出口" :class="{onhover:isExport}" @click="trade_E('出口')">出口</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="dashboard_title">
            {{province}}({{toptimeShow}})
          </div>
          <div class="dashboard__tabs2 clearfix">
            <div class="dashboard__column fl">
              <h1 class="h1 h--list">
                Top5
                <span style="color:#2c3e50;font-size:12px;margin-left:60px;font-weight:400;">单位：百万美元</span>
              </h1>
              <div v-show="chart11_chart">
                <div ref="lineChartsTop5" id="lineChartsTop5" style="margin:0 auto; width:100%; height:200px;"></div>
              </div>
              <img
                v-show="chart11_img"
                src="../../assets/imgs/cgitchartdefault.jpg"
                style="margin:0 auto; height:200px;;width: 100%;"
              />
            </div>
            <div class="dashboard__column fl">
              <h1 class="h1 h--list">
                  同比增长最快
                  <!-- <span title="Compound annual growth rate (CAGR)">{{timeName}}</span> -->
              </h1>
              <ol class="list">
                  <li class="list__item" v-for="(item,index) in increase" :key="index">
                    <div class="list__row">
                      <div class="list__cell list__cell--counter">{{index+1}}</div>
                      <div class="list__cell list__cell--title" :title="item.state_name">
                        <span>{{item.state_name}}</span>
                      </div>
                      <div class="list__cell list__cell--value">+{{item.rate}}%</div>
                    </div>
                  </li>
              </ol>
            </div>
            <div class="dashboard__column fl">
                <h1 class="h h1 h--list">
                  同比下降最快
                  <!-- <span title="Compound annual growth rate (CAGR)">{{timeName}}</span> -->
                </h1>
                <ol class="list">
                  <li class="list__item" v-for="(item,index) in decline" :key="index">
                    <div class="list__row">
                      <div class="list__cell list__cell--counter">{{index+1}}</div>
                      <div class="list__cell list__cell--title" :title="item.state_name">
                        <span>{{item.state_name}}</span>
                      </div>
                      <div class="list__cell list__cell--value">{{item.rate}}%</div>
                    </div>
                  </li>

                </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="dashboard__charts fl" style="position: relative;">
        <div class="bj_white2" style="height: 350px;">
          <div class="card_title">
            <h1 id="lineChartTrendtitle">中国对外货物贸易总额趋势图</h1>
          </div>
          <div class="full_box" @click="openAlert('lineChartTrend')"></div>
          <div ref="lineCharts" id="lineCharts" style="margin:0 auto; width:95%; height:300px;"></div>
        </div>
      </div>
    </div>
    <!-- 图表2 -->
    <div class="home p5 clearfix">
      <div class="w50 fl">
        <div class="bj_white2">
          <div class="card_title">
            <h1 id="lineChartLtitle">{{province}}对{{queryCountry}}{{specialPort}}同比增速变化
              <!-- <span style="color:red">50/23</span> -->
            </h1>
          </div>
          <div v-show="chart21_chart">
            <div class="full_box" @click="openAlert('lineChartL')"></div>
            <div ref="lineChartL" id="lineChartL" style="margin:0 auto; width:95%; height:330px;"></div>
            <!-- <p style="font-size:12px;text-align:right;margin:0px 6px 6px;" v-show="((time.indexOf('2020') !== -1) && (time.length > 4))">* 2020年2月同比增速为2020年1-2月贸易汇总数与2019年1-2月贸易汇总数的同比增长率</p> -->
          </div>
          <img
            v-show="chart21_img"
            src="../../assets/imgs/cgitchartdefault.jpg"
            style="margin:0 auto; height:330px;width: 100%;"
          />
          
        </div>
      </div>
      <div class="w50 fl">
        <div class="bj_white2">
          <div class="card_title">
            <h1 id="lineChartRtitle">{{province}}对{{queryCountry}}货物贸易差额变化趋势</h1>
          </div>
          <div v-show="chart22_chart">
            <div class="full_box" @click="openAlert('lineChartR')"></div>
            <div ref="lineChartR" id="lineChartR" style="margin:0 auto; width:95%; height:330px;"></div>
            <!-- <p style="font-size:12px;text-align:right;margin:0px 6px 6px;" v-show="((time.indexOf('2020') !== -1) && (time.length > 4))">* 2020年2月贸易差额为2020年1-2月出口汇总数减去2020年1-2月进口汇总数</p> -->
          </div>
          <img
            v-show="chart22_img"
            src="../../assets/imgs/cgitchartdefault.jpg"
            style="margin:0 auto; height:330px;width: 100%;"
          />
        </div>
      </div>
    </div>
    <!-- 图表3 -->
    <div class="home p5 clearfix" style="position: relative;">
      <div class="w50 fl">
        <div class="box1 bj_white2">
          <div class="card_title">
            <h1 id="barChartLtitle">{{province}}出口目的地TOP10({{toptimeShow}})
            </h1>
          </div>
          <div v-show="chart31_chart">
            <div class="full_box" @click="openAlert('barChartL')">
            </div>
            <div ref="barChartL" id="barChartL" style="margin:0 auto; width:95%; height:330px;"></div>
          </div>
          <img
            v-show="chart31_img"
            src="../../assets/imgs/cgitchartdefault.jpg"
            style="margin:0 auto; height:330px;width: 100%;"
          />
        </div>
      </div>
      <div class="w50 fl">
        <div class="box1 bj_white2">
          <div class="card_title">
            <h1 id="barChartRtitle">{{province}}进口来源地TOP10({{toptimeShow}})</h1>
          </div>
          <div v-show="chart32_chart">
            <div class="full_box" @click="openAlert('barChartR')"></div>
            <div ref="barChartR" id="barChartR" style="margin:0 auto; width:95%; height:330px;"></div>
          </div>
          <img
            v-show="chart32_img"
            src="../../assets/imgs/cgitchartdefault.jpg"
            style="margin:0 auto; height:330px;width: 100%;"
          /> 
        </div>
      </div>
      <p style="position:absolute;bottom:-14px;right:0px;font-size:14px;">资料来源：图中数据是由海关统计数据在线查询平台（http://43.248.49.97）公布数据汇总得出。</p>
    </div>

    <!-- 放大框 -->
    <div class="alertBox" style="display:black" :class="{open:isOpen}" v-show='showAlertBox'>
      <!-- 关闭标签 -->
      <div class="alertBigBox_close" @click="closeAlert">
        <!-- <img src="@/assets/imgs/close.png"/> -->
      </div>
      <h3>{{alertTitle}}</h3>
      <!-- 放入图表 -->
      <div ref="alertChart" id="alertChart" style="margin:0 auto; width:95%; height:88%;"></div>
    </div>
    <backTop v-show="backTopShow"/>
    <Footer />
  </div>
</template>

<script>
import Top from "@/components/top";
import Footer from "@/components/footer";
import backTop from "@/components/BackTop";
import SelectTree from "@/components/treeSelect.vue";
import {api} from "@/require/api"
import { initCharts } from "../../assets/js/world_trade.js";
// import "../../../node_modules/echarts/map/js/world.js";
// 树形下拉框
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: {
    Top,
    Footer,
    SelectTree,
    backTop,
    Treeselect
  },
  data() {
    return {
      // 选项
      province: "",
      provinces: [],
      country:'全部经济体',
      queryCountry:'全部经济体',
      tabnum: 0, 
      valuelayer: false, // 下拉所有区域是否有下级，true是一级，false是二级
      optionData: [],
      optionData1: [],
      optionData2: [],
      optionData3: [],
      //"所有区域"下拉框
      isClearable: true, // 可清空（可选）
      isAccordion: true, // 可收起（可选）
      props: {
        // 配置项（必选）
        value: "value",
        label: "name",
        children: "children"
      },
      port: "",
      ports: [],
      specialPort: '',
      time: "",
      // timeName:'',
      options: [],
      // widths: "0%",
      // heigths: "200px",
      // 流向图
      showExplain: true, // 流向图上的说明字段是否显示
      worldData: [],
      trapeze: {},
      option: {
        title: {
          text: "单位：百万美元",
          x: "right",
          padding: [15, 60, 0, 0],
          textStyle: {
            fontSize: 12,
            fontWeight: "normal",
            color: "#333"
          }
        },
        toolbox: {
          right: 25,
          itemGap: 15, // 工具栏 icon 每项之间的间隔
          itemSize: 13, // 工具栏 icon 的大小
          feature: {
            saveAsImage: {}, // 保存图片
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line" // 默认为直线，可选为：'line' | 'shadow'
          },         
        },
        grid: {
          left: "2%",
          right: "4%",
          bottom: "5%",
          top: "15%",
          containLabel: true
        },
        legend: {
          top: "3%",
          data: []
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisLabel:{
            interval: 2
          }
        },
        yAxis: {
          type: 'value',
          scale: true
        },
        series: []
        // xAxis.axisLabel.interval  X轴间隔
      },
      parallelOption: {
        title: {
          text: "单位：百万美元",
          x: "right",
          padding: [10, 60, 0, 0],
          textStyle: {
            fontSize: 12,
            fontWeight: "normal",
            color: "#fff"
          }
        },
        color:['#37BBF8'],
        // legend: {
        //   top: 80,
        //   data: []
        // },
        tooltip: {
          // padding: 10,
          borderColor: '#777',
        },
        parallelAxis: [],  // 这是一个个『坐标轴』的定义
        parallel: {  // 这是『坐标系』的定义
          left: '5%',
          right: '5%',
          top: 130,
          bottom: 60,
          axisExpandable: true,
          axisExpandCenter: 5,
          axisExpandCount: 6,
          axisExpandWidth: 140,
          parallelAxisDefault: {
            type: 'value',
            nameLocation: 'start',
            nameGap: 20,
            nameTextStyle: {
              color: '#fff',
              fontSize: 12,
            },
            axisLine: {
              lineStyle: {
                color: '#aaa'
              }
            },
            axisTick: {
              lineStyle: {
                color: '#777'
              }
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            }
          }
        },
        series:{
          name: '',
          type: 'parallel',
          lineStyle: {
            normal: {
              width: 3,
              opacity: 0.5
            }},
          data: [[1,55,9,56,0.46,18,6]]
        },
      },
      // 点击高亮
      isIExport: true,
      isImport: false,
      isExport: false,
      // Top
      increase:[],
      decline:[],
      // 弹出框
      isOpen: false,
      showAlertBox: false,
      lineOptionTrend: {},
      parallelOptionL: {},
      parallelOptionR: {},
      barOptionLeft:{},
      barOptionRight:{},
      alertTitle:'',
      clickIoreNameVal:'',
      searchBarFixed: false, //下拉搜索框
      backTopShow: true,
      toptimeShow:'', // 底部Top图表的时间提示
      newTime:'',
      // 无数据的显示
      chart11_chart: true,
      chart11_img: false,
      chart21_chart: true,
      chart21_img: false,
      chart22_chart: true,
      chart22_img: false,
      chart31_chart: true,
      chart31_img: false,
      chart32_chart: true,
      chart32_img: false
    };
  },
  created() {
    // 下拉框
    this.getTradeDimensions()
    // 贸易总额趋势图
    this.loadTrend()
    // this.windowSize();
    this.initTrapeze()
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮滚动事件
    // 绘制地图左上角的环形图
    // let pieOption = {
    //     color:['#1DB7E5', '#e6e6e6'],
    //     series: [
    //         {
    //             name: '',
    //             type: 'pie',
    //             radius: ['95%', '70%'],
    //             hoverAnimation: false,
    //             label: {
    //                 normal: {
    //                     show: true,
    //                     position: 'center',
    //                     fontSize: '14',
    //                 },
    //             },
    //             data: [
    //                 {value: 35, name: '20%'},
    //                 {value: 310, name: ''},
    //             ],
    //         }
    //     ]
    // };
    // let pieChart = this.$echarts.init(document.getElementById("pieChart"));
    // pieChart.setOption(pieOption);
    // window.addEventListener("resize", pieChart.resize);
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll); //  离开页面清除（移除）滚轮滚动事件
  },
  watch:{
    // 监听port变化 “进出口总数” =》 “进出口总额”
    port: {
      deep: true,
      // immediate: true,
      handler: function(newV, oldV) {
        if (newV === '进出口总数') {
          this.specialPort = '进出口总额'
        }else{
          this.specialPort = newV
        }
      }
    },
    country:{
      deep: true,
      // immediate: true,
      handler: function(newV, oldV) {
        // this.queryCountry = newV.slice(0,newV.lastIndexOf('('))
        newV.slice(newV.lastIndexOf('(')+1,newV.length-1) > 50 ? (this.showExplain = true) : (this.showExplain = false)
      }
    }
  },
  methods: {
    // 下拉框
    async getTradeDimensions(){
      const{code, data} = await api.get('/data/dimension/getTradeDimensions')
      if(code === 0){
        if(data.length === 0)  return;
        this.provinces = data.regions
        this.province = data.regions[0].value
        this.options = data.times
        this.newTime = data.times[0].children[0].id
        this.time = data.times[0].children[0].id
        this.timeTip()
        this.ports = data.iores
        this.port = data.iores[0].name

        // 父级后面追加子级的数量(开始)
        data.states[0].name = data.states[0].name + '('+(data.states.length-1)+')'
        this.optionData = data.states
        data.areas.forEach(item => {
          item.name = item.name + '('+(item.children.length)+')'
        })
        this.optionData1 = data.areas
        data.groups.forEach(item => {
          item.name = item.name + '('+(item.children.length)+')'
        })
        this.optionData2 = data.groups
        data.ydylCountrys[0].name = data.ydylCountrys[0].name + '('+(data.ydylCountrys.length-1)+')'
        this.optionData3 = data.ydylCountrys
        // 父级后面追加子级的数量(结束)

        
        this.loadTopRateByTimeRegion('进出口总数',true)
        this.loadTopRateByTimeRegion('进出口总数',false)
        this.loadRateByRegion()
        this.loadBalanceByRegion()
        this.loadTopByTimeRegion('进出口总数',5)
        this.loadTopByTimeRegion('出口',10)
        this.loadTopByTimeRegion('进口',10)
      }
    },
    // 底部Top图表的时间提示
    timeTip(){
      let yearMax = this.newTime.slice(0,4)
      // console.log(this.newTime,'this.newTime')
      // console.log(this.time.lastIndexOf('-'),'this.time')
      if (this.time.length === 4) {
        if (this.time === yearMax) {
          this.toptimeShow = this.time + '年01月-' + this.newTime.slice(5,this.newTime.lastIndexOf('-')) + '月'
        }else{
          this.toptimeShow = this.time + '年01月-12月'
        }
      }else{
        this.toptimeShow = this.time.slice(0,4) + '年' + this.time.slice(5,this.time.lastIndexOf('-')) + '月'
      }
    },
    // 下拉搜索固定
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.getElementById("searchBar").offsetTop;
      scrollTop > offsetTop
        ? (this.searchBarFixed = true)
        : (this.searchBarFixed = false);
    },
    
    getProvince(val){
      this.province = val;
      this.initChart()
      this.loadRateByRegion()
      this.loadBalanceByRegion()
      this.clickIoreNameVal.length === 0 ? this.clickIoreNameVal = '进出口总数' : this.clickIoreNameVal
      this.loadTopByTimeRegion(this.clickIoreNameVal,5)
      this.loadTopRateByTimeRegion(this.clickIoreNameVal,true)
      this.loadTopRateByTimeRegion(this.clickIoreNameVal,false)
      this.loadTopByTimeRegion('出口',10)
      this.loadTopByTimeRegion('进口',10)
    },
    getValue(value) { 
      this.country = value.split(',')[0];
      if (this.country.lastIndexOf(')') === this.country.length-1) {
        this.queryCountry = this.country.slice(0,this.country.lastIndexOf('('))
      }else{
        this.queryCountry = this.country
      }
      
      this.tabnum = value.split(",")[2];
      this.valuelayer = value.split(",")[3];//是否有儿子，true表示有儿子，如果是false,tabnum需要设置为0
      if (this.valuelayer=="false") this.tabnum = 0;
      if (this.queryCountry === '全部一带一路经济体') this.tabnum = 3;
      this.initChart()
      this.loadRateByRegion()
      this.loadBalanceByRegion()
    },
    getPort(val){
      this.port = val;
      this.initChart()
      this.loadRateByRegion()
    },
    valueInput(val){
      this.time = val;
      this.timeTip()
      this.initChart()
      this.loadRateByRegion()
      this.loadBalanceByRegion()
      this.clickIoreNameVal.length === 0 ? this.clickIoreNameVal = '进出口总数' : this.clickIoreNameVal
      this.loadTopByTimeRegion(this.clickIoreNameVal,5)
      this.loadTopRateByTimeRegion(this.clickIoreNameVal,true)
      this.loadTopRateByTimeRegion(this.clickIoreNameVal,false)
      this.loadTopByTimeRegion('出口',10)
      this.loadTopByTimeRegion('进口',10)
    },
    //流向图
    async initTrapeze(){
      const { code, data } = await api.get("/cgitController/getGeoMapData",{
        dbType:2
      })
      if(code === 0){
        this.trapeze = data
        for (let key in this.trapeze) {
          let coordX = this.trapeze[key][0];
          if (coordX <= -30) {
            this.trapeze[key][0] = 360 + coordX;
          }
        }
        // this.initChart()
      }
    },
    async initChart() {
      const { code, data } = await api.get("/tradeController/getFlowMap", {
        timeId: this.time,
        regionName: this.province,
        ioreName: this.port,
        stateName: this.queryCountry,
        queryType: this.tabnum 
      });
      this.worldData = []
      if (code === 0) {
        // data.length === 0 ? this.worldData = [] : this.worldData = data;
        this.worldData = data
        // console.log(this.worldData)
      }
      let chartmap = this.$echarts.init(document.getElementById("myEchart"));
      //随屏幕大小缩放
      window.addEventListener("resize", chartmap.resize);
      this.chart = this.$echarts.init(this.$refs.myEchart);
      initCharts(this.chart,this.worldData,this.trapeze); //world_CGIT.js
    },
    // windowSize() {
    //   this.width = document.documentElement.clientWidth;
    //   this.heigth = document.documentElement.clientHeight;
    // },
    // 点击切换高亮
    trade_IE(val){
      this.isIExport = true
      this.isImport = false
      this.isExport = false
      this.clickIoreNameVal = val
      this.loadTopByTimeRegion(val,5)
      this.loadTopRateByTimeRegion(val,true)
      this.loadTopRateByTimeRegion(val,false)
    },
    trade_I(val){
      this.isIExport = false
      this.isImport = true
      this.isExport = false
      this.clickIoreNameVal = val
      this.loadTopByTimeRegion(val,5)
      this.loadTopRateByTimeRegion(val,true)
      this.loadTopRateByTimeRegion(val,false)
    },
    trade_E(val){
      this.isIExport = false
      this.isImport = false
      this.isExport = true
      this.clickIoreNameVal = val
      this.loadTopByTimeRegion(val,5)
      this.loadTopRateByTimeRegion(val,true)
      this.loadTopRateByTimeRegion(val,false)
    },
    // Top
    async loadTopByTimeRegion(ioreNameVal,topNumVal){
      const { code, data } = await api.get("/tradeController/getTopByTimeRegion",
      {timeId:this.time,regionName:this.province,ioreName:ioreNameVal,topNum:topNumVal})
      if(topNumVal === 5){
        if (code === 0) {
          // ===== Top5 dollar
          let barOptionTop = JSON.parse(JSON.stringify(this.option));
          barOptionTop.title.text = ''
          barOptionTop.toolbox = {}
          barOptionTop.grid = {
              left: "0%",
              right: "-10%",
              bottom: "0%",
              top: "-8%",
              // containLabel: true
          },
          barOptionTop.xAxis = {show: false,type: 'value',position: 'top',}
          barOptionTop.yAxis = {
            show:false,
            type: 'category',
            data: []
          }
          barOptionTop.series = {
            itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0,
                    [{
                      offset: 0,
                      color: '#db3971 '
                    },
                    {
                      offset: 1,
                      color: '#04aced'
                    }]
                  )
                }
            },
            label:{
                 normal: {
                    show: true,
                    textStyle: {
                      color: '#000',
                      fontSize: 12,
                      fontWeight: 'bold'
                    },
                    formatter: '{b}                     ${c}',
                    position: [0, '20'],
                }
            },
            // name: this.time,
            type: 'bar',
            barWidth: '40%',
            data: []
          }
          let dataTop5 = []
          // 无数据显示处理
          // if(data.length !== 0){
          //   dataTop5 = data     
          // }
          let nullData = 0
          dataTop5 = data 
          dataTop5.forEach(item => {
            if(item.dollar === null){
              nullData = nullData + 1
            }
          })
          if (nullData === dataTop5.length) {
            this.chart11_chart = false
            this.chart11_img = true
          }else{
            this.chart11_chart = true
            this.chart11_img = false
            dataTop5.reverse().forEach(item => {
              barOptionTop.yAxis.data.push(item.state_name)
              barOptionTop.series.data.push(item.dollar)
            })
            let lineChartsTop5 = this.$echarts.init(document.getElementById("lineChartsTop5"));
            lineChartsTop5.setOption(barOptionTop);
            window.addEventListener("resize", lineChartsTop5.resize);
          }
        }
      }else if(topNumVal === 10){
        if (code === 0) {
            let barOption = JSON.parse(JSON.stringify(this.option));
            barOption.xAxis = {type: 'value',position: 'top',scale: true}
            barOption.yAxis = {
            type: 'category',
            data: []
            }
            barOption.series = {
              itemStyle: {
                normal: {
                  barBorderRadius:[0, 10, 10, 0],
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0,
                    [
                      {offset: 0, color: '#3977E6'},
                      {offset: 1, color: '#37BBF8'}
                    ]
                  )
                }
              },
              type: 'bar',
              barWidth: '60%',
              data: []
            }
            let barOptionL = JSON.parse(JSON.stringify(barOption));
            let barOptionR = JSON.parse(JSON.stringify(barOption));
            let dataTop10 = [] 
            if (data.lenght !== 0) {
               dataTop10 = data
            }
            // 无数据显示的处理
            let nullData = 0
            dataTop10.forEach(item => {
              if(item.dollar === null){
                nullData = nullData + 1
              }
            })
            // 
            if (ioreNameVal === '进口') {
              if (nullData === dataTop10.length) {
                this.chart31_chart = false
                this.chart31_img = true
              }else{
                this.chart31_chart = true
                this.chart31_img = false
                  dataTop10.reverse().forEach(item => {
                  barOptionR.yAxis.data.push(item.state_name)
                  barOptionR.series.data.push(item.dollar)
                })
                let barChartR = this.$echarts.init(document.getElementById("barChartR"));
                barChartR.setOption(barOptionR);
                this.barOptionRight = barOptionR
                // 改变x轴y轴颜色
                this.barOptionRight.title.textStyle.color = '#fff'
                this.barOptionRight.xAxis.axisLabel = {
                  color: '#fff',
                },
                this.barOptionRight.xAxis.axisLine = {
                  lineStyle: {
                    color: '#fff'
                  }
                },
                this.barOptionRight.yAxis.axisLabel = {
                  color: '#fff',
                },
                this.barOptionRight.yAxis.axisLine = {
                  lineStyle: {
                    color: '#fff'
                  }
                },
                this.barOptionRight.xAxis.splitLine = {
                    lineStyle: {
                        // 使用深浅的间隔色
                        type: 'dotted'
                    }
                }
                window.addEventListener("resize", barChartR.resize);
              }
            }else{
              if (nullData === dataTop10.length) {
                this.chart32_chart = false
                this.chart32_img = true
              }else{
                this.chart32_chart = true
                this.chart32_img = false
                dataTop10.reverse().forEach(item => {
                  barOptionL.yAxis.data.push(item.state_name)
                  barOptionL.series.data.push(item.dollar)
                })
                let barChartL = this.$echarts.init(document.getElementById("barChartL"));
                barChartL.setOption(barOptionL);
                this.barOptionLeft = barOptionL
                // 改变x轴y轴颜色
                this.barOptionLeft.title.textStyle.color = '#fff'
                this.barOptionLeft.xAxis.axisLabel = {
                  color: '#fff',
                },
                this.barOptionLeft.xAxis.axisLine = {
                  lineStyle: {
                    color: '#fff'
                  }
                },
                this.barOptionLeft.yAxis.axisLabel = {
                  color: '#fff',
                },
                this.barOptionLeft.yAxis.axisLine = {
                  lineStyle: {
                    color: '#fff'
                  }
                },
                this.barOptionLeft.xAxis.splitLine = {
                    lineStyle: {
                        // 使用深浅的间隔色
                        type: 'dotted'
                    }
                }
                window.addEventListener("resize", barChartL.resize);
              }
            } 
        }
      }
    },
    // 增速和降速
    async loadTopRateByTimeRegion(ioreNameVal,descVal){
      const{code, data} = await api.get('/tradeController/getTopRateByTimeRegion',
      {timeId:this.time,regionName:this.province,ioreName:ioreNameVal,topNum:5,desc:descVal})
      if (code === 0) {
        if(data === null) return
        data.forEach(item => {
          item.rate = Math.floor(item.rate * 1000) / 1000
        })
        if (descVal === true) {
          this.increase = data;
        }else{
          this.decline = data;
        } 
      }
    },
    // 贸易总额趋势图
    async loadTrend(){
      const { code, data } = await api.get("/tradeController/getTrend")
      if(code === 0){
        let trendData = data
        let lineOption = JSON.parse(JSON.stringify(this.option));
        lineOption.legend.data = ['进口','出口','进出口总数']
        lineOption.legend.left = 3
        lineOption.legend.top = 3
        lineOption.title.padding = [26, 60, 0, 0]
        lineOption.xAxis.data = []
        lineOption.series = []
        trendData['出口'].forEach(item => {
          lineOption.xAxis.data.push(item.__time)
        });
        Object.entries(trendData).forEach(item => {
            lineOption.series.push({
              name:item[0],
              type:'line',
              data:item[1]
            }) 
        })
        lineOption.series.forEach(item => {
          let yAxisData = []
          item.data.forEach(ele => {
            yAxisData.push(ele.dollar)
          })
          item.data = yAxisData
        })
        this.lineOptionTrend = JSON.parse(JSON.stringify(lineOption));
        // 改变x轴y轴颜色
        this.lineOptionTrend.title.textStyle.color = '#fff'
        this.lineOptionTrend.legend.textStyle = {
          color:'#fff'
        }
        this.lineOptionTrend.toolbox = {}
        this.lineOptionTrend.xAxis.axisLabel = {
          color: '#fff',
        },
        this.lineOptionTrend.xAxis.axisLine = {
          lineStyle: {
            color: '#fff'
          }
        },
        this.lineOptionTrend.yAxis.axisLabel = {
          color: '#fff',
        },
        this.lineOptionTrend.yAxis.axisLine = {
          lineStyle: {
            color: '#fff'
          }
        },
        this.lineOptionTrend.yAxis.splitLine = {
          lineStyle: {
              // 使用深浅的间隔色
              type: 'dotted'
          }
        }
        let mychart = this.$echarts.init(document.getElementById("lineCharts"));
        mychart.setOption(lineOption);
        window.addEventListener("resize", mychart.resize);
      }
    },
    // =======华丽分割线
    async loadRateByRegion(){
      const { code, data } = await api.get("/tradeController/getRateByRegion",{timeId:this.time,regionName:this.province,ioreName:this.port,stateName:this.queryCountry,queryType:this.tabnum})
      if(code === 0){
        let nullData = 0
        data.forEach(item => {
          if(item.rate === null){
            nullData = nullData + 1
          }
        })
        if (nullData === data.length) {
          this.chart21_chart = false
          this.chart21_img = true
        }else{
          this.chart21_chart = true
          this.chart21_img = false
          let RateByRegionData = data.reverse()
          let lineOptionL = JSON.parse(JSON.stringify(this.option));
          this.parallelOptionL = JSON.parse(JSON.stringify(this.parallelOption));
          lineOptionL.title.text = '单位：%',
          lineOptionL.tooltip.formatter = '{b} : {c}%'
          this.parallelOptionL.title.text = '单位：%'
          this.parallelOptionL.series.name = this.province
          lineOptionL.xAxis.data = []
          lineOptionL.series = {
            data: [],
            type: 'line',
            smooth: true
          }
          this.parallelOptionL.parallelAxis = []
          this.parallelOptionL.series.data[0] = []
          RateByRegionData.forEach((item,index) => {
            lineOptionL.xAxis.data.push(item.time_id)
            lineOptionL.series.data.push(item.rate)
            this.parallelOptionL.parallelAxis.push({dim: index,name:item.time_id})
            this.parallelOptionL.series.data[0].push(item.rate)
            
          });
          let mychartL = this.$echarts.init(document.getElementById("lineChartL"));
          mychartL.setOption(lineOptionL);
          window.addEventListener("resize", mychartL.resize);
        }
      }
    },
    async loadBalanceByRegion(){ 
      const { code, data } = await api.get("/tradeController/getBalanceByRegion",{timeId:this.time,regionName:this.province,stateName:this.queryCountry,queryType:this.tabnum})
      if(code === 0){
        let nullData = 0
        data.forEach(item => {
          if(item.balance === null){
            nullData = nullData + 1
          }
        })
        if (nullData === data.length) {
          this.chart22_chart = false
          this.chart22_img = true
        }else{
          this.chart22_chart = true
          this.chart22_img = false
          let BalanceByRegionData = data.reverse()
          let lineOptionR = JSON.parse(JSON.stringify(this.option));
          this.parallelOptionR = JSON.parse(JSON.stringify(this.parallelOption));
          this.parallelOptionR.series.name = this.province
          lineOptionR.xAxis.data = []
          lineOptionR.series = {
            data: [],
            type: 'line',
            smooth: true
          }
          BalanceByRegionData.forEach((item,index) => {
            lineOptionR.xAxis.data.push(item.time_id)
            lineOptionR.series.data.push(item.balance) 
            this.parallelOptionR.parallelAxis.push({dim: index,name:item.time_id})
            this.parallelOptionR.series.data[0].push(item.balance)
          });
          let mychartR = this.$echarts.init(document.getElementById("lineChartR"));
          // mychart.clear();
          mychartR.setOption(lineOptionR);
          window.addEventListener("resize", mychartR.resize);
        }
      }
    },
    openAlert(Val) {
      // 禁止鼠标滑过滚动条滚动
      // document.body.onmousewheel = function () {return false;}
      this.showAlertBox = true
      this.isOpen = true
      this.backTopShow = false
      let alertOption = {},alertCharts
      if (Val === 'lineChartTrend') {
        alertOption = this.lineOptionTrend
        this.alertTitle = document.getElementById('lineChartTrendtitle').innerHTML
      }else if (Val === 'barChartL') {
        alertOption = this.barOptionLeft
        this.alertTitle = document.getElementById('barChartLtitle').innerHTML
      }else if(Val === 'barChartR'){
        alertOption = this.barOptionRight
        this.alertTitle = document.getElementById('barChartRtitle').innerHTML
      }else if(Val === 'lineChartL'){      
        alertOption = this.parallelOptionL
        this.alertTitle = document.getElementById('lineChartLtitle').innerHTML
      }else if(Val === 'lineChartR'){
        alertOption = this.parallelOptionR
        this.alertTitle = document.getElementById('lineChartRtitle').innerHTML
      }
      setTimeout(() => {
        alertCharts = this.$echarts.init(document.getElementById("alertChart"));
        alertCharts.setOption(alertOption);
        window.addEventListener("resize", alertCharts.resize);
      }, 1000);
    },
    closeAlert(){
      // 恢复鼠标滑过滚动条滚动
      // document.body.onmousewheel = function () {return true;}
      this.showAlertBox = false
      this.isOpen = false;
      let alertCharts = this.$echarts.init(document.getElementById("alertChart"));
      alertCharts.clear()
    }
  }
};
</script>

<style lang='less' scoped>
/deep/.guides{
  display: none!important;
}
.alertBox {
  position: fixed;
  z-index: 99999;
  top: 0px;
  left: 0px;
  background: black;
  opacity: 0.9;
  .alertBigBox_close {
    position: absolute;
    top: 20px;
    right:20px;
    z-index: 1000;
    height: 18px;
    width: 18px;
    background: url('../../assets/imgs/close.png') center;
    background-size: 18px 18px;
    cursor: pointer;
  }
  .alertBigBox_close:hover{
    background: url('../../assets/imgs/close_hover.png') center;
    background-size: 18px 18px;
  }
  h3{
    color: #fff;
    height: 8%;
    font-size: 20px;
    text-align: center;
    padding: 3%;
    box-sizing: border-box;
  }
}
@keyframes open {
  0% {
    height: 0%;
    width: 0%;
  }
  100% {
    height: 100%;
    width: 100%;
  }
}
.open {
  animation: open 0.8s forwards ease-in;
}
.card_title {
  background: url(../../assets/imgs/titlebj.png) repeat-x top;
  height: 45px;
  line-height: 45px;
  border-bottom: 1px solid #d7dfe3;
  border-left: 1px solid #d7dfe3;
  margin-left: -1px;
  h1 {
    text-align: center;
    line-height: 45px;
    font-weight: 600;
    font-size: 15px;
  }
}
.dashboard_title{
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    background: #f2f2f2;
    box-shadow: 0 0 10px #f2f2f2;
    border-radius: 30px;
    width: 72%;
    margin: 10px auto 0px;
}
// 标题
.trade {
  background: #fff;
  box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.05);
  .bt_title {
    color: #1260af;
    text-align: center;
    display: block;
    font-weight: bold;
    height: 55px;
    line-height: 55px;
    font-size: 22px;
  }
}
// 选择框
// 下拉搜索固定
.searchBar {
  position: fixed;
  background-color: #edf4f8;
  top: 0;
  width: 99.5%;
  height: 50px;
  z-index: 9999;
}
.fade{
  height: 0px;
  width: 0px;
}
.select {
  height: 50px;
  .table_r_box {
    z-index: 1000;
    right: 10px;
    margin-top: 6px;
    .bg_a {
      background: #cce7ff url(../../assets/imgs/tableimg.png) no-repeat 15px
        10px;
      display: block;
      border: 1px solid #a3d4ff;
      width: 115px;
      color: #0058b2;
      height: 34px;
      line-height: 34px;
      padding-left: 35px;
      font-size: 15px;
    }
  }
  .screen {
    padding: 6px 0 5px 0;
    padding-right: 125px;
    box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.15);
    .w25 {
      width: 25%;
      padding: 0 5px;
      position: relative;
      .wrap {
        height: 34px;
        border: 0;
        position: relative;
        /deep/.el-input,
        .el-select {
          display: block;
        }
        /deep/.el-input {
          width: 100%;
        }
        /deep/.el-input__inner  {
          width: 100%;
          border: 1px solid transparent;
          border-bottom: 1px solid #222833;
          background: transparent;
          border-radius: 8px;
          color: #222833;
        }
        /deep/.el-input__inner:hover{
          border-bottom: 1px solid #4996dd;
          color: #4996dd;
        }
        /deep/.el-icon-arrow-up:before {
            content: "\e6e1";
            color: #222833;
        }
      }
    }
  }
}
.el-select{
  width: 100%!important;
  height: 100%;
}
/deep/.el-input--suffix{
  height: 100%!important;
}
/deep/.el-input__inner{
  height: 100%;
}
/deep/.el-popper{
  min-width: 26px!important;
  position: absolute!important;
  top: 31px!important;
}
// /deep/.el-popper{
//   min-width: 263.25px!important;
//   position: absolute!important;
//   top: 162px!important;
// }
.el-select-dropdown .el-input__inner .el-scrollbar__wrap{
  margin-right:0px!important;
}

// 地图
.mapbox {
  padding: 5px 10px;
  position: relative;
  .intro{
    position: absolute;
    bottom: 20px;
    right: 30px;
    width: 700px;
    font-size: 15px;
    text-align: right;
  }
}
// 图表
.dashboard__tabs {
  padding: 0 5px;
  width: 75%;
  .bj_white2 {
    .card_title {
      .title {
        position: absolute;
        .nav_tab li {
          float: left;
          border-right: 1px solid #d7dfe3;
          height: 45px;
          line-height: 45px;
          span {
            color: #393c40;
            font-size: 15px;
            display: block;
            padding: 0 20px;
            cursor: pointer;
          }
          span:hover {
            background: #4996dd;
            box-shadow: 5px 5px 5px #00649d inset;
            color: #fff;
            display: block;
          }
        }
      }
    }
    .dashboard__tabs2{
      height: 264px;
      .dashboard__column {
        height: 100%;
        padding: 0 16px;
        width: 33.33333%;
      }
    }
  }
}
.onhover{
  background: #4996dd!important;
  box-shadow: 5px 5px 5px #00649d inset!important;
  color: #fff!important;
  display: block!important;
}
.dashboard__charts {
  width: 25%;
  padding: 0 5px;
}

.h--list {
  position: relative;
  padding: 10px 0px;
  font-size: 15px;
  font-weight: bold;
}
.list__item {
  display: block;
  position: relative;
  padding: 8px 0px;
  line-height: 25px;
  font-size: 14px;
  border-top: 1px solid #dee5e5;
  cursor: pointer;
}
.list__cell + .list__cell {
  padding-left: 6px;
}
.list__cell--title {
  width: 100%;
  text-align: left;
}
.list__cell--value {
  text-align: right;
  white-space: nowrap;
}
.list__cell {
  display: table-cell;
}

// .h--list > span {
//   position: absolute;
//   right: 0;
//   top: 0.75rem;
//   font-size: 12px;
//   line-height: 1.5rem;
//   color: #666;
// }
// 图表2
.w50 {
  width: 50%;
  padding: 0 5px;
  position: relative;
}
.full_box {
  position: absolute;
  right: 20px;
  top: 55px;
  z-index: 999;
  width: 18px;
  height: 18px;
  background: url(../../assets/imgs/fdimg.png) center;
}
.full_box:hover{
  background: url(../../assets/imgs/fdimg_hover.png) center;
  cursor: pointer;
}
/deep/.vue-treeselect__control{
  border: 0px;
  border-bottom: 1px solid #222833;
  background: transparent;
  height: 34px;
}
/deep/.vue-treeselect__control:hover{
  border-bottom: 1px solid #4996dd!important;
  color: #4996dd!important;
  cursor: pointer!important;
}
/deep/.vue-treeselect__single-value{
  cursor: pointer!important;
}
</style>